import { blogOgHashes } from '@/data/blog-og';

// Fallback gradients, shown only while a post's generated hero card is
// absent — in dev before `npm run prebuild` has run. Production always has
// the PNG from scripts/generate-blog-og-images.mjs.
export const CATEGORY_GRADIENTS = {
  'ACSC Essential Eight': 'from-[#5B2C91] via-[#8B3A8F] to-[#D8456F]',
  'People': 'from-[#3B5998] via-[#2C7A9B] to-[#1BA098]',
  'Security Assessment': 'from-[#B8315A] via-[#D8456F] to-[#F54952]',
  'Compliance & Governance': 'from-[#059669] via-[#10B981] to-[#34D399]',
  'Technology': 'from-[#4F46E5] via-[#6366F1] to-[#818CF8]',
  'Process': 'from-[#0891B2] via-[#06B6D4] to-[#22D3EE]',
  'Microsoft 365': 'from-[#0078D4] via-[#106EBE] to-[#00B4D8]',
  'Azure Security': 'from-[#0078D4] via-[#106EBE] to-[#00B4D8]',
  'Security Culture': 'from-[#3B5998] via-[#2C7A9B] to-[#1BA098]',
  'Privacy & Compliance': 'from-[#059669] via-[#10B981] to-[#34D399]',
  'SharePoint Governance': 'from-[#0EA5E9] via-[#106EBE] to-[#00B4D8]',
  'Ebook': 'from-[#7C3AED] via-[#5B21B6] to-[#4C1D95]',
};

export const DEFAULT_GRADIENT = 'from-[#422680] via-[#660F56] to-[#F54952]';

export function getCategoryGradient(category) {
  return CATEGORY_GRADIENTS[category] || DEFAULT_GRADIENT;
}

/**
 * Generated 1200x630 hero card for a post.
 *
 * The generator owns this path unconditionally — `post.image` is not consulted.
 * An audit of the 38 posts that set it found zero bespoke artwork: 25 pointed at
 * files that have never existed in this repo and 13 reused one of five batch
 * assessment cards, one of them shared across five posts. To supply bespoke art
 * for a post, drop the PNG at this path and add the slug to the skip-list in
 * scripts/generate-blog-og-images.mjs — one path, one mechanism.
 */
export function getBlogHeroImage(post) {
  const hash = blogOgHashes[post?.slug];
  return `/images/blog/og/${post?.slug}.png${hash ? `?v=${hash}` : ''}`;
}
